import { CostTableRow } from "../types/CostTableRow";

export const licenseSuggestions: CostTableRow[] = [
  {
    id: "admin",
    name: "Admin",
    listPrice: 79,
    discount: 0,
    amount: 1,
  },
  {
    id: "manager",
    name: "Manager",
    listPrice: 79,
    discount: 0,
    amount: 1,
  },
  {
    id: "member",
    name: "Member",
    listPrice: 79,
    discount: 0,
    amount: 1,
  },
  {
    id: "viewer",
    name: "Viewer",
    listPrice: 10,
    discount: 0,
    amount: 1,
  },
];
